import useTeamInvitation from '../../auth/useTeamInvitation';
import React from "react";
import usePricingPlans from '../../PricingPlans/usePricingPlans';
import { useNavigate } from 'react-router-dom';

import "./UserPricing.scss";
import "./YearlyPlan/YearlyPlan.scss";
import YearlyPlan from "./YearlyPlan/YearlyPlan";
import MonthlyPlan from "./MonthlyPlan/MonthlyPlan";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Planarrow from "../../../assets/icons/Big arrow.svg";

import "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function UserPricingPlans() {
  const navigate = useNavigate();
  const { priceListY, priceListM, isLoading, error } = usePricingPlans(true);

  useTeamInvitation('team');

  const createSubscription = async (planId, priceId, type, planPrice) => {
    localStorage.setItem('subscriptionType', type);
    localStorage.setItem('subscriptionplanId', planId);
    localStorage.setItem('subscriptionpriceId', priceId);
    localStorage.setItem('planPrice', planPrice / 100);
    navigate('/app/paymentScreen');
  }

  if (error) return <div role="alert">{error}</div>;
  return (
    <>
      {isLoading ? (
        <div className="App-loading">
          <div className="App-logo" title="Zimzee" />
        </div>
      ) : (
        <div className="userpricing-plans">
          <div className="page-heading">
            <h3>Pricing Plans</h3>
            <p>Choose the perfect plan for you</p>
          </div>

          <Tabs>
            <div className="pricingfiles-content">
              <TabList>
                <Tab>Monthly</Tab>
                <Tab>Yearly</Tab>
              </TabList>
              <div className="save-plan">
                <div className="sec-sectio">
                  <h6>Save up to 33%</h6>
                  <h6>Only $33.25/month</h6>
                  <h6>Billed annually<span className="saveplan-text"> (Save ~$189)</span></h6>
                  <img className="planarrow-imgcontent" src={Planarrow} alt="chrome-icon" />
                </div>
              </div>
            </div>

            <TabPanel>
              <MonthlyPlan priceListM={priceListM} createSubscription={createSubscription} />
            </TabPanel>
            <TabPanel>
              <YearlyPlan priceListY={priceListY} createSubscription={createSubscription} />
            </TabPanel>
          </Tabs>
        </div>
      )}
    </>
  );
}
export default UserPricingPlans;
